import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { SupervisorDTO } from "app/main/apps/shared/interfaces/supervisores.interface";
import { NuevoRepresentanteDTO } from "app/main/apps/shared/models/representante.model";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { finalize } from "rxjs/operators";
import { DialogUsuarioComponent } from "../../clientes/detalle-cliente/components/dialog-usuario/dialog-usuario.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";

@Component({
    selector: "app-supervisores",
    templateUrl: "./supervisores.component.html",
    styleUrls: ["./supervisores.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class SupervisoresComponent implements OnInit {
    listaSupervisores: SupervisorDTO[];
    superSupervisor: boolean;
    constructor(
        private _usuarioSrvc: UsuarioService,
        private _notificacionSrvc: NotificacionesService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _dialogSrvc: DialogService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        public _menuUsuarioSrvc: MenuUsuarioService
    ) {
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
        this.superSupervisor = this._menuUsuarioSrvc.puedeRealizarAccion(
            null,
            "puedeCrearOtros"
        );
    }

    ngOnInit(): void {
        this.buscarSupervisor();
    }

    buscarSupervisor() {
        this._usuarioSrvc.fetchSupervidores().subscribe((resp) => {
            this.listaSupervisores = resp;
            this._usuarioSrvc.supervisoresChanged$.next(this.listaSupervisores);
        });
    }

    /*
  guardarSupervisor(supervisor: NuevoRepresentanteDTO){
    console.log('llego a grabar');
    this._fuseProgressBarService.show();
    this._usuarioSrvc.guardaSupervisor(supervisor)
      .pipe(finalize(() => this._fuseProgressBarService.hide()))
      .subscribe(resp=>{
        this._notificacionSrvc.mostrarNotificacion(
          "Supervisor guardado con exito ",
          "success"
        );
        this.buscarSupervisor();
      })
  }
*/
    deleteSupervisor(data: any) {
        const { rut, nombre } = data;
        const dialogRef = this._dialogSrvc.abrirDialogConfirm(
            "Eliminar supervisor",
            `¿Esta seguro que quiere eliminar al supervisor ${nombre}?`
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                this._usuarioSrvc
                    .deleteSupervisor(rut)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Supervisor ha sido eliminado",
                            "success"
                        );
                        this.buscarSupervisor();
                    });
            }
        });
    }

    nuevo() {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogUsuarioComponent,
            "clase-dialog",
            "500px",
            { editar: false }
        );

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this._fuseProgressBarService.show();
                let nuevo = new NuevoRepresentanteDTO(
                    result.rut.split("-")[0],
                    result.rut.split("-")[1],
                    result.nombres,
                    result.apellidos,
                    result.correo
                );

                this._usuarioSrvc
                    .guardaSupervisor(nuevo)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this.buscarSupervisor();
                        this._notificacionSrvc.mostrarNotificacion(
                            "El Supervisor ha sido registrado exitosamente",
                            "success"
                        );
                    });

                //console.log(c);
            }
        });
    }
}
